<div class=" pt-4 pb-4 pl-md-5 pr-md-5 masthead bg-white">
    <div class="row align-items-center">
        <div class="col">
            <p class="h3 mb-0" *ngIf="itemConfigSet">
                <i class="fa mr-3 fa-globe"></i>
                <a class="text-info" routerLink="/countries"><strong>Countries</strong></a>
                <i class="fa fa-angle-right text-muted mr-2 ml-2"></i>
                <span class="text">{{itemConfigSet?.country.shortName}}</span>
            </p>
        </div>
        <div class="col text-right" *ngIf="itemConfigSet">
            <button class="btn btn-sm btn-outline-danger ml-2" (click)="onRejectPrompt()" *ngIf="itemConfigSet?.canReject">
                Reject changes <i class="fa fa-close ml-2"></i>
            </button>
            <button class="btn btn-sm btn-outline-secondary" (click)="onRevertPrompt()" *ngIf="itemConfigSet?.canRevert">
                Cancel draft <i class="fa fa-lock ml-2"></i>
            </button>
            <button class="btn btn-sm btn-primary ml-2" (click)="onApprovePrompt()" *ngIf="itemConfigSet?.canSendForReview">
                Send for review <i class="fa fa-check ml-2"></i>
            </button>
            <button class="btn btn-sm btn-primary ml-2" (click)="onPublishPrompt()" *ngIf="itemConfigSet?.canPublish">
                {{itemConfigSet?.workflowStages?.length > 0 ? "Approve & ": ""}}Publish <i class="fa fa-rss ml-2"></i>
            </button>
            <button class="btn btn-sm btn-primary ml-2" (click)="onCreateDraftPrompt()" *ngIf="itemConfigSet?.canCreateDraft">
                Create draft <i class="fa fa-unlock ml-2"></i>
            </button>
        </div>
    </div>
</div>

<div class="row justify-content-between m-0 mh-100">
    <div class="col p-5">
        <div>
            <div class="mb-5" *ngIf="(itemConfigSet?.statusId == countryDataStatus.Draft) && itemConfigSet?.workflowStages.length > 0">
                <workflowstagedatastatus *ngIf="itemConfigSet" [workflowStages]="itemConfigSet.workflowStages"></workflowstagedatastatus>
            </div>
            <h3 class="h4 mb-4 mt-2">
                Categories for {{itemConfigSet?.country.shortName}}
            </h3>
            <ul class="list-group">
                <li class="list-group-item list-group-item-action justify-content-between align-items-center" *ngFor="let item of itemConfigSet?.itemConfigs" [routerLink]="'/countries/' + itemConfigSet?.country.code + '/' + item.id">
                    <div>
                        <p class="mb-0">
                            <strong>{{item.name}}</strong>
                        </p>
                    </div>
                    <div>
                        <ul class="nav">
                            <li class="nav-item">
                                <small class="text-muted" *ngIf="item.lastUpdatedText"><em>{{item.lastUpdatedText}}</em></small>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="col col-md-4 drawer drawer-right" [ngClass]="{'drawer-closed': commentsHidden}" *ngIf="itemConfigSet.statusId == countryDataStatus.Draft">
        <div class="drawer-handle"(click)="toggleComments()"></div>
        <div class="drawer-contents p-md-5">
             <countrydatatimeline
                [events]="itemConfigSet.countryDataTimelineEvents"
                [countryDataId]="itemConfigSet.countryDataId"
                [workFlowStageId]="itemConfigSet.workflowStages[0]?.id"
                [countryName]="itemConfigSet.country.shortName"
                [countryCode]="itemConfigSet.country.code"></countrydatatimeline>
        </div>
    </div>
</div>

<latestupdatemodal #latestUpdateModal [(latestUpdate)]="updateText" (onLatestUpdateUpdated)="publishContent($event);"></latestupdatemodal>

<confirmationmodal #revertModal [confirmationText]="'Are you sure you want to revert this draft? This action cannot be undone.'" (onAccept)="onRevert();"></confirmationmodal>

<commentsmodal #commentsModal (onCommentsUpdated)="onCommentsModalSubmit($event.comments);"></commentsmodal>

